// ─────────────────────────────────────────────────────────────────────────────
// RESILIENCE SCREENER — Question Bank
// 25 Likert items (0=Not at all true → 4=True nearly all the time)
// Science: CD-RISC adapted (Connor & Davidson 2003, open domain after 2017)
//          NEO-PI Emotional Stability facet · Duckworth Grit Scale constructs
// Dimensions: Hardiness · Recovery · Adaptability · Self-Efficacy · Emotional Control
// Market: Healthcare · Call centres · Armed forces · Field sales · High-pressure roles
// ─────────────────────────────────────────────────────────────────────────────
// Note: CD-RISC-10 is in open domain since 2017 (Connor & Davidson public release)
// Scale: 0=Not at all true, 1=Rarely true, 2=Sometimes true, 3=Often true, 4=Nearly always true

export const RESILIENCE_ITEMS = [
  // ── HARDINESS (items 0-4) ─────────────────────────────────────────────────
  { id:"rs01", dim:"H", q:"I am able to adapt when changes occur at work." },
  { id:"rs02", dim:"H", q:"I can deal with whatever comes my way, even under pressure." },
  { id:"rs03", dim:"H", q:"I try to see the humorous side of things when I face problems." },
  { id:"rs04", dim:"H", q:"Having to cope with stress can make me stronger." },
  { id:"rs05", dim:"H", q:"I tend to bounce back after illness, injury or other hardships." },

  // ── RECOVERY (items 5-9) ──────────────────────────────────────────────────
  { id:"rs06", dim:"R", q:"After a setback or failure, I recover quickly." },
  { id:"rs07", dim:"R", q:"I can switch off from work-related stress when I am not at work." },
  { id:"rs08", dim:"R", q:"I do not dwell on failures or disappointments for long." },
  { id:"rs09", dim:"R", q:"I bounce back quickly after a difficult day or difficult situation." },
  { id:"rs10", dim:"R", q:"I take steps to actively recover after intense or stressful periods." },

  // ── ADAPTABILITY (items 10-14) ────────────────────────────────────────────
  { id:"rs11", dim:"A", q:"I can handle uncertainty — I don't always need to know what will happen next." },
  { id:"rs12", dim:"A", q:"When plans fall apart, I quickly think of another way forward." },
  { id:"rs13", dim:"A", q:"I work well even in stressful or unpredictable environments." },
  { id:"rs14", dim:"A", q:"I stay focused on what I can control, rather than what I cannot." },
  { id:"rs15", dim:"A", q:"I find it easy to accept change, even when it is uncomfortable." },

  // ── SELF-EFFICACY (items 15-19) ───────────────────────────────────────────
  { id:"rs16", dim:"E", q:"I believe I can achieve my goals even when things are difficult." },
  { id:"rs17", dim:"E", q:"I have a strong sense of purpose that keeps me going in tough times." },
  { id:"rs18", dim:"E", q:"I feel I have control over how I respond to difficult situations." },
  { id:"rs19", dim:"E", q:"Past successes give me confidence when I face new challenges." },
  { id:"rs20", dim:"E", q:"I believe that even very difficult problems have solutions." },

  // ── EMOTIONAL CONTROL (items 20-24) ──────────────────────────────────────
  { id:"rs21", dim:"C", q:"I stay calm and think clearly even when under pressure." },
  { id:"rs22", dim:"C", q:"I am able to manage my emotions well during stressful interactions." },
  { id:"rs23", dim:"C", q:"I don't let my emotions get in the way of making rational decisions." },
  { id:"rs24", dim:"C", q:"When things go wrong, I react calmly rather than becoming overwhelmed." },
  { id:"rs25", dim:"C", q:"I can stay professional and composed even when someone is rude or aggressive towards me." },
];

export const RESILIENCE_DIMS = {
  H: { id:"H", label:"Hardiness",        fullLabel:"Hardiness & Durability",     icon:"🪨", color:"#7c3aed",
       desc:"Withstands pressure, sees challenges as growth opportunities, remains stable." },
  R: { id:"R", label:"Recovery",          fullLabel:"Recovery Speed",              icon:"⚡", color:"#0891b2",
       desc:"Bounces back quickly from setbacks, separates work stress from personal life." },
  A: { id:"A", label:"Adaptability",      fullLabel:"Adaptability & Flexibility",  icon:"🔄", color:"#059669",
       desc:"Handles uncertainty, finds alternative paths, stays effective in unpredictable environments." },
  E: { id:"E", label:"Self-Efficacy",     fullLabel:"Self-Efficacy & Purpose",     icon:"🎯", color:"#d97706",
       desc:"Believes in own capability, has clear purpose, confident despite difficulty." },
  C: { id:"C", label:"Emotional Control", fullLabel:"Emotional Control",           icon:"🧘", color:"#dc2626",
       desc:"Manages emotional responses, stays calm under provocation, clear-headed under pressure." },
};
